class DynamicContentRestrictedProductGroupController {
    constructor($state, $rootScope, $timeout, $document, productGroupService, trolleyService, settings, settingsService, dialogRegistry, $sce) {
        this.$state = $state;
        this.$timeout = $timeout;
        this.$document = $document;
        this.productGroupService = productGroupService;
        this.trolleyService = trolleyService;
        this.settings = settings;
        this.enableCheckoutButton = false;
        this.hasSettingValidated = false;
        this.settingsService = settingsService;
        this.dialogRegistry = dialogRegistry;
        this.$sce = $sce;

        this.removeNoScroll();

        $rootScope.$on('trolley:update', () => {
            this.removeNoScroll();
            if (this.hasSettingValidated === false || this.trolleyService.itemCount === 0 || this.trolleyService.itemCount === 1) {
                this.settingsService.invalidate().then(() => {
                    this.updateCheckoutButtonStatus();
                    this.hasSettingValidated = true;
                });
            } else {
                this.updateCheckoutButtonStatus();
            }
        });
    }

    $onInit() {
        this.productGroupService.selectProductGroup(this.productGroupId).then((group) => {
            this.productGroupDetails = group;
            this.toggleDialog(true);
        });
        this.updateCheckoutButtonStatus();
    }

    removeNoScroll() {
        this.$timeout(() => { this.$document.find('body').removeClass('noscroll'); }, 300);
    }

    updateCheckoutButtonStatus() {
        this.enableCheckoutButton = this.trolleyService.itemPriceTotal >= this.settings.checkout.minimumSpend && this.trolleyService.HasPfdItems;
    }

    shouldShowCategories() {
        return this.productGroupService.categories.length > 0;
    }

    toggleDialog(showDialog) {
        const popupMessageDialog = this.dialogRegistry.getDialog('popupMessage');

        if (showDialog) {
            if (popupMessageDialog && this.settings.pfd.productListPageAlertMessage && this.trolleyService.itemCount !== 0) {
                popupMessageDialog.show();
            }
        } else {
            popupMessageDialog.close();
        }
    }
}

const dynamicContentRestrictedProductGroupComponentDefinition = {
    bindings: {
        productGroupId: '@',
    },
    controller: DynamicContentRestrictedProductGroupController,
    template: require('./dynamic-content-restricted-product-group.component.html').trim(),
};

DynamicContentRestrictedProductGroupController.$inject = ['$state', '$rootScope', '$timeout', '$document', 'ProductGroupService', 'TrolleyService', 'Settings', 'SettingsService', 'DialogRegistry', '$sce'];
module.exports = {
    DynamicContentRestrictedProductGroupController,
    dynamicContentRestrictedProductGroupComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/restrictedproductgroup/dynamic-content-restricted-product-group.component.js